export default __webpack_public_path__ + "static/media/button talkback-3.3ce3e5d2.png";